import { ApiResponse } from '@/lib/api/api-response';
import { goApiClient } from '@/lib/api/base-client';
import { LocationStartBalanceCreateDTO, GetLocationDTO, GetAssetTypeDTO } from './location-start-balance.contracts';

export class LocationStartBalanceService {
  public basePath = 'location-start-balance';

  async create(data: LocationStartBalanceCreateDTO): Promise<ApiResponse<void>> {
    try {
      const response = await goApiClient.post<void>(this.basePath, data);
      return response;
    } catch (error) {
      return ApiResponse.UnknownErrorResponse();
    }
  }

  async getLocation(id: number): Promise<ApiResponse<GetLocationDTO>> {
    try {
      const response = await goApiClient.get<GetLocationDTO>(`${this.basePath}/${id}`);
      return response;
    } catch (error) {
      return ApiResponse.UnknownErrorResponse();
    }
  }

  async getAssetTypesWithFirstTransactionDate(locationId: number): Promise<ApiResponse<GetAssetTypeDTO[]>> {
    try {
      const response = await goApiClient.get<GetAssetTypeDTO[]>(`${this.basePath}/${locationId}/asset-types`);
      return response;
    } catch (error) {
      return ApiResponse.UnknownErrorResponse();
    }
  }
}

export const locationStartBalanceService = new LocationStartBalanceService();
